import React, { useState } from 'react';
import DemoPopover from './DemoPopover';

const ACTIONS = [
  {
    id:    'seeker',
    label: "I'm looking for a job",
    desc:  'Seekers, students, fresh grads',
    btn:   'Start job search →',
    style: 'bg-brand-purple text-white shadow-purple',
  },
  {
    id:    'hiring',
    label: "I'm hiring",
    desc:  'Companies, recruiters, agencies',
    btn:   'Post a job free →',
    style: 'bg-brand-saffron text-white shadow-saffron',
    href:  'https://recruiter.jobxbharat.com/',
  },
  {
    id:    'college',
    label: 'I represent a college',
    desc:  'TPOs, placement cells, directors',
    btn:   'Book a demo →',
    style: 'bg-ink-900 text-white shadow-glass',
  },
];

export default function FinalCTA({ onStartSearching }) {
  const [showDemo, setShowDemo] = useState(false);

  return (
    <>
      <section className="px-4 sm:px-6 py-12 md:py-20 bg-paper border-t border-gray-100">
        <div className="max-w-7xl mx-auto text-center mb-8 md:mb-14">
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-ink-900 tracking-tight mb-4">
            Ready to start?
          </h2>
          <p className="text-ink-500 text-lg md:text-xl max-w-xl mx-auto">
            Join the most complete employment ecosystem in India.
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-6">
          {ACTIONS.map(a => (
            <div key={a.id}
                 className="p-6 md:p-8 rounded-3xl bg-white border border-gray-100
                            hover:shadow-glass-lg hover:-translate-y-1 transition-all
                            flex flex-col gap-4">
              <h3 className="font-display font-black text-xl text-ink-900">{a.label}</h3>
              <p className="text-sm text-ink-500 flex-1">{a.desc}</p>
              {a.href ? (
                <a
                  href={a.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`px-6 py-3 rounded-xl font-black text-sm tracking-wide text-center
                              hover:brightness-110 active:scale-95 transition-all ${a.style}`}
                >
                  {a.btn}
                </a>
              ) : (
                <button
                  onClick={a.id === 'college' ? () => setShowDemo(true) : onStartSearching}
                  className={`px-6 py-3 rounded-xl font-black text-sm tracking-wide
                              hover:brightness-110 active:scale-95 transition-all ${a.style}`}
                >
                  {a.btn}
                </button>
              )}
            </div>
          ))}
        </div>
      </section>

      <DemoPopover open={showDemo} onClose={() => setShowDemo(false)} />
    </>
  );
}
